import router from './router'
import { accessedRoutes } from './router/permission'
// import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken, removeToken, setToken } from '@/utils/token' // get token from cookie
import { stroeGetInfo, stroeGetBase } from '@/utils/store'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login'] // no redirect whitelist

window.addEventListener('beforeunload', e => {
  sessionStorage.clear()
})

if (process.env.NODE_ENV === 'development') {
  // setToken('eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3NzY0MTk1NTAsImp0aSI6IjY5Y2JlZmExYTAwNDRjMDAwMTM4MjBhNyIsImlhdCI6MTc3NjQwNTE1MCwiaXNzIjoiV29uZGZvQWlvdFBsYXRmb3JtMjAxOWJldGEiLCJuYmYiOjE3NzY0MDUxNTAsInN1YiI6IntcInVzZXJJZFwiOlwiNjljYmVmYTFhMDA0NGMwMDAxMzgyMGE3XCIsXCJuYW1lXCI6XCLpmYjkv4rlhahcIixcImFjY291bnRcIjpcIjE0MzQ5XCIsXCJwb3NpdGlvblwiOlwi5pm66IO95LqS6IGU57uELeW8gOWPkeW3peeoi-W4iFwifSJ9.hxpt3CCzC2vNWuMBTqcUidaFrVidHlBtG8LUPGL01Pk')
}

router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()

  // determine whether the user has logged in
  const hasToken = getToken()

  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/', query: to.query })
      NProgress.done()
    } else {
      // determine whether the user has obtained his permission roles through getInfo
      const info = JSON.parse(sessionStorage.getItem('info'))
      // console.log(info)
      if (info) {
        next()
      } else {
        try {
          // get user info
          await stroeGetInfo()
          await stroeGetBase()
          const info = JSON.parse(sessionStorage.getItem('info'))
          const accessRoutes = accessedRoutes(info.buzAuth)
          // console.log(accessRoutes)
          router.addRoutes(accessRoutes)

          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next({ ...to, replace: true })
        } catch (error) {
          console.error(error)
          // remove token and go to login page to re-login
          removeToken()
          // Message.error(error || 'Has Error')
          next({
            path: '/login', // 目标路径
            query: to.query // 保留原 URL 的查询参数
          })
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      // next('/login')
      next({
        path: '/login', // 目标路径
        query: to.query // 保留原 URL 的查询参数
      })
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
